














import { Prop, Component } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';

@Component({
  name: 'SectionTitle',
})
export default class SectionTitle extends BaseComponent {
  @Prop() title!: string;
  @Prop({ default: true }) divider?: boolean;
}
